function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import "core-js/modules/es.regexp.exec.js"; //# sourceMappingURL=Suggestion.js.map
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import { TrackingContext } from '../../../shared/components/TrackingProvider';
import { useTranslate } from '../../../shared/components/TranslationsProvider';
import BaseLink from '../../../shared/components/BaseLink';
import Icon from '../../../shared/components/Icon';
import Typography from '../../../shared/components/Typography';
import Image from '../../../shared/components/Image';
import { theme } from '../../../shared/const/theme';
import useScrollIntoView from '../hooks/useScrollIntoView';
export var SuggestionType;
(function(SuggestionType) {
    SuggestionType["KEYWORD"] = "KEYWORD";
    SuggestionType["BRAND"] = "BRAND";
    SuggestionType["SCOPED_BRAND"] = "SCOPED_BRAND";
    SuggestionType["BRAND_IN_CATEGORY"] = "BRAND_IN_CATEGORY";
    SuggestionType["SUB_CATEGORY"] = "SUB_CATEGORY";
    SuggestionType["CATEGORY"] = "CATEGORY";
    SuggestionType["RECENT_SEARCH"] = "RECENT_SEARCH";
    SuggestionType["PAGE"] = "PAGE";
    SuggestionType["MERCHANT"] = "MERCHANT";
    SuggestionType["PRODUCT"] = "PRODUCT";
    SuggestionType["FEATURE"] = "FEATURE";
    SuggestionType["CAMPAIGN"] = "CAMPAIGN";
    SuggestionType["STORE"] = "STORE";
    SuggestionType["APPLE_TERM"] = "APPLE_TERM";
})(SuggestionType || (SuggestionType = {}));
const SUBTITLE_CATEGORY_TYPES = [
    SuggestionType.SUB_CATEGORY,
    SuggestionType.SCOPED_BRAND,
    SuggestionType.FEATURE
];
const Wrapper = styled.li.withConfig({
    componentId: "sc-375543a1-0"
})([
    ``
]);
const Link = styled(BaseLink).withConfig({
    componentId: "sc-375543a1-1"
})([
    `display:flex;flex-wrap:nowrap;align-items:center;padding:8px 16px;color:`,
    `;&:hover{background:`,
    `;}&:active{background:`,
    `;}`,
    ` &:focus:not(:active){border-radius:4px;box-shadow:inset 0px 0px 0px 2px #5c32b8;}`
], (p)=>{
    var _a;
    return (_a = p.$color) !== null && _a !== void 0 ? _a : '#0E0E0F';
}, theme.button.white.outlined.hover, theme.button.white.outlined.pressed, (p)=>p.$active && `
      background: ${theme.button.white.outlined.hover};
    `);
const StyledWrapper = styled.span.withConfig({
    componentId: "sc-375543a1-2"
})([
    `align-items:baseline;`
]);
const HighlightLink = styled(Link).withConfig({
    componentId: "sc-375543a1-3"
})([
    `display:list-item;background:#feedf2;border-radius:8px;padding:8px 16px;margin:8px 16px;&:hover{background:#feedf2;span{text-decoration:unset;}}&:focus:not(:active){border-radius:8px;}`,
    ``
], (p)=>p.$active && `
      background:rgb(255, 219, 231);
    `);
const HighlightLinkTitle = styled(Typography).withConfig({
    componentId: "sc-375543a1-4"
})([
    `margin-right:8px;line-height:24px;`
]);
const HighlightLinkSubtitle = styled(Typography).withConfig({
    componentId: "sc-375543a1-5"
})([
    `text-decoration:underline;text-underline-offset:4px;line-height:24px;`
]);
const IconFallback = styled.div.withConfig({
    componentId: "sc-375543a1-6"
})([
    `width:16px;`
]);
const Title = styled(Typography).withConfig({
    componentId: "sc-375543a1-7"
})([
    `margin:0 -4px 0 8px;line-height:24px;`
]);
const Subtitle = styled(Typography).withConfig({
    componentId: "sc-375543a1-8"
})([
    `margin-left:8px;`
]);
const Subcategories = styled.ul.withConfig({
    componentId: "sc-375543a1-9"
})([
    `margin:0;padding:0;list-style:none;`
]);
const LogoWrapper = styled.div.withConfig({
    componentId: "sc-375543a1-10"
})([
    `box-sizing:border-box;width:32px;height:32px;border-radius:50%;overflow:hidden;`
]);
const MerchantLink = styled(Link).withConfig({
    componentId: "sc-375543a1-11"
})([
    `justify-content:space-between;`,
    ``
], (p)=>p.$active && `
      background: ${theme.button.white.outlined.pressed};
    `);
const StyledIcon = styled(Icon).withConfig({
    componentId: "sc-375543a1-12"
})([
    `min-width:20px;min-height:20px;`
]);
const MerchantLinkIconWrapper = styled.div.withConfig({
    componentId: "sc-375543a1-13"
})([
    `box-sizing:border-box;width:30px;height:30px;display:flex;justify-content:center;align-items:center;background-color:#f3f3f7;border-radius:50%;overflow:hidden;`
]);
const MerchantLinkInfoWrapper = styled.div.withConfig({
    componentId: "sc-375543a1-14"
})([
    `display:flex;align-items:center;`
]);
const Suggestion = /*#__PURE__*/ forwardRef(({ title, subtitle, highlighted, href, type, subcategories, titleColor, target, onClick, logo, active }, ref)=>{
    const t = useTranslate();
    const liRef = useRef(null);
    useScrollIntoView(active, liRef);
    useImperativeHandle(ref, ()=>({
            focus: ()=>{
                var _a;
                const anchorElement = (_a = liRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('a');
                if (anchorElement) {
                    anchorElement.focus();
                }
            }
        }));
    const handleClick = useCallback(()=>{
        onClick({
            title,
            type,
            url: href
        });
    }, [
        title,
        href,
        type
    ]);
    const typeTranslationString = useMemo(()=>{
        return type.toLowerCase().replace(/_./g, (g)=>g.substring(1).toUpperCase());
    }, [
        type
    ]);
    if (type === SuggestionType.CAMPAIGN || type === SuggestionType.APPLE_TERM || type === SuggestionType.STORE && highlighted) {
        return _jsx("li", {
            ref: liRef,
            children: _jsx(TrackingContext, {
                link: {
                    text: title
                },
                children: _jsxs(HighlightLink, {
                    href: href,
                    target: target,
                    onClick: handleClick,
                    "$color": titleColor,
                    "$active": active,
                    children: [
                        _jsx(HighlightLinkTitle, {
                            as: "span",
                            children: title
                        }),
                        _jsx(HighlightLinkSubtitle, {
                            as: "span",
                            children: subtitle
                        })
                    ]
                })
            })
        });
    }
    if (type === SuggestionType.MERCHANT && logo) {
        return _jsx(Wrapper, {
            ref: liRef,
            children: _jsx(TrackingContext, {
                link: {
                    text: title
                },
                children: _jsxs(MerchantLink, {
                    target: target,
                    href: href,
                    onClick: handleClick,
                    "$active": active,
                    "$color": titleColor,
                    children: [
                        _jsxs(MerchantLinkInfoWrapper, {
                            children: [
                                _jsx(LogoWrapper, {
                                    children: _jsx(Image, {
                                        src: logo,
                                        alt: "",
                                        width: 32,
                                        height: 32
                                    })
                                }),
                                _jsx(Title, {
                                    fontSize: "body",
                                    color: "inherit",
                                    noMargin: true,
                                    children: title
                                })
                            ]
                        }),
                        _jsx(MerchantLinkIconWrapper, {
                            children: _jsx(Icon, {
                                name: "Link"
                            })
                        })
                    ]
                })
            })
        });
    }
    return _jsx(Wrapper, {
        ref: liRef,
        children: _jsxs(TrackingContext, {
            link: {
                text: title
            },
            children: [
                _jsxs(Link, {
                    target: target,
                    href: href,
                    onClick: handleClick,
                    "$active": active,
                    "$color": titleColor,
                    children: [
                        type !== SuggestionType.BRAND_IN_CATEGORY ? _jsx(StyledIcon, {
                            name: "Search",
                            color: "#5F6163"
                        }) : _jsx(IconFallback, {}),
                        _jsxs(StyledWrapper, {
                            children: [
                                _jsx(Title, {
                                    fontSize: "body",
                                    color: "inherit",
                                    noMargin: true,
                                    children: title
                                }),
                                subtitle && _jsx(Subtitle, {
                                    fontSize: "tiny",
                                    color: "#615F6D",
                                    noMargin: true,
                                    children: SUBTITLE_CATEGORY_TYPES.includes(type) ? `${t('within')} ${subtitle}` : t(typeTranslationString)
                                })
                            ]
                        })
                    ]
                }),
                subcategories && _jsx(Subcategories, {
                    children: subcategories === null || subcategories === void 0 ? void 0 : subcategories.map((suggestion, index)=>/*#__PURE__*/ _createElement(Suggestion, _object_spread_props(_object_spread({}, suggestion), {
                            key: index,
                            onClick: onClick,
                            active: active,
                            title: `${t('within')} ${suggestion.title}`,
                            titleColor: "#5F6163"
                        })))
                })
            ]
        })
    });
});
Suggestion.displayName = 'Suggestion';
export default Suggestion;
